<template>
    <div class="pd20x flex1">
        <Loading v-if="loading"></Loading>
        <addCourseBook :visible="visible" @close="visible = false" :data="currentItem" @update="getData"></addCourseBook>
        <div class="h100pct ofA">
            <div class="filter pd20x mb10x">
                <div>科目名称 : {{name}}</div>
                <div>
                    <a-button type="primary" @click="addItem">添加</a-button>
                </div>
            </div>
            <a-table
                    :columns="columns"
                    :data-source="result"
                    :pagination="pagination"
                    :rowKey="'id'"
                    @change="changePage"
            >
                <template slot="name" slot-scope="text">
                    {{ text }}
                </template>
                <template slot="years" slot-scope="text">
                    {{ moment(text).format("YYYY-MM") }}
                </template>
                <template slot="showList" slot-scope="text, record,index">
                    <a-switch :defaultChecked="record.show" @change="setShow(index,record.id)"/>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a-space>
                        <a-button type="primary" style="margin-right:10px" @click="()=>{currentItem = record ; visible = true}">修改</a-button>
                        <a-button type="primary" ghost style="margin-right:10px" @click="toZhangj(record)">章节</a-button>
                        <a-button type="primary" ghost style="margin-right:10px" @click="deleteItem(record.id)">删除</a-button>
                    </a-space>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
    const columns = [
        {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'className' },
            align:'center'
        },{
            title: '主编',
            dataIndex: 'editor',
            align:'center'
        },{
            title: '出版社',
            dataIndex: 'publisher',
            align:'center'
        },{
            title: '出版年份',
            dataIndex: 'years',
            scopedSlots: { customRender: 'years' },
            align:'center'
        },{
            title: '教材定价',
            dataIndex: 'price',
            align:'center'
        }, {
            title: '展示状态',
            dataIndex: 'show',
            align:'center',
            scopedSlots: { customRender: 'showList' },
        }, {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    import * as http from '@/libs/analysis'
    import addCourseBook from '@/components/analysis/addCourseBook'
    import Loading from '@/components/loading'
    import moment from 'moment'
    export default {
        name: 'courseBook',
        components: { Loading, addCourseBook },
        data(){
            return{
                result: [],
                columns,
                visible: false,
                loading: true,
                currentItem: [],
                name: '',
                classId : '',
                total: 0,
                filter:{
                    cate_id: 0,
                    keywords:''
                },
                pagination:{
                    page: 1,
                    size: '15',
                    pageSize: 15
                },
            }
        },
        mounted(){
          if (this.$route.query.class)
            this.filter.cate_id = this.$route.query.class;
          if (this.$route.query.name)
            this.name = this.$route.query.name;
          this.$nextTick(()=>{
            this.getData()
          })
        },
        methods:{
            moment,
            toZhangj(record) {
              this.$router.push({path:'/analysis/questionUnit', query: { class: this.filter.cate_id, bookId:record.id, name: this.name, bookName: record.name }})
            },
            changePage({current}){
                this.pagination.page = current
                this.getData()
            },
            setShow(index , id){
                this.loading = true
                http.show_course_book({id:id}).then(res=>{
                    this.loading = false;
                    this.result[index]['show'] = !this.result[index]['show'];
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            getData(){
                this.result = [];
                this.loading = true;
                let request = {...this.filter,...this.pagination}
                http.get_course_book(request).then(res=>{
                    this.loading = false
                    this.result = res.data
                    this.total = res.total
                }).catch(error=>{
                    this.loading = false
                    console.log(error)
                })
            },
            handleChange(){

            },
            onSelectChange(){

            },
            addItem(){
                this.currentItem = [];
                this.visible = true;
            },
            deleteItem(id){
                let _this = this
                this.$confirm({
                    title: '是否确定删除该教材吗?',
                    centered: true,
                    onOk() {
                        http.del_course_book({id}).then(res=>{
                            _this.getData()
                        }).catch(error=>{
                            console.log(error)
                        })
                    },
                });
            },
            hideModal(){

            }
        }
    }
</script>
<style lang="less" scoped>

</style>
